// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2eBo2","buttons":"Footer_buttons__2u1cr"};